import { render } from "./NoLayout.vue?vue&type=template&id=39c8a4f9"
import script from "./NoLayout.vue?vue&type=script&lang=js"
export * from "./NoLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__